
const performanceCookieCategory = 'C0002,';

function waitForOneTrust() {
  hasOneTrustLoaded();
  let attempts = 0;
  const interval = setInterval(function () {
    if (hasOneTrustLoaded() || attempts > 100){
      clearInterval(interval);
    } 
    attempts++;
  }, 100)
}

function hasOneTrustLoaded() {
  if(typeof window.OnetrustActiveGroups === 'string'){
    optanonWrapper()
    window.OptanonWrapper = optanonWrapper;
    return true;
  }
  return false;
}

function sendConsent(trackingConsent) {
  window.Shopify.customerPrivacy.setTrackingConsent(trackingConsent, () => {
    console.log('Happy Days')
  });
}

function optanonWrapper() {
  const trackingConsent = !!window.OnetrustActiveGroups.includes(performanceCookieCategory);        
  window.Shopify.loadFeatures(
    [
      {
        name: 'consent-tracking-api',
        version: '0.1',
      },
    ],
    error => {
      if (error) {
        throw error; 
      }
      sendConsent(trackingConsent)
    },
  );   
}
(function () {
  waitForOneTrust();
})();


class SwiperElement extends HTMLElement {
  swiper; options;

  constructor(){
    super();
    this.init();
  } 

  init = () => {
    this.options = {};
    if(this.dataset.breakpoints != undefined){
      this.options.breakpoints = {};
      const points = this.dataset.breakpoints.split(';');
      points.forEach((point) => {
        const bp = point.split(':');
        this.options.breakpoints[bp[0]] = {
          slidesPerView: bp[1]
        }
      });
    }
    if(this.dataset.direction != undefined){
      this.options.direction = this.dataset.direction;
    }
    if(this.dataset.navigation != undefined){
      this.options.navigation = {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      };
    }
    if(this.dataset.autoplay != undefined){
      this.options.autoplay = {
        delay: parseInt(this.dataset.autoplay) <= 0 ? 2500 : parseInt(this.dataset.autoplay),
        disableOnInteraction: false
      };
    }
    if(this.dataset.touch == 'false'){
      this.options.allowTouchMove = false;
    }
    if(this.dataset.autowidth != undefined){
      this.slidesPerView = 'auto';
    }
    this.swiper = new Swiper(this, this.options);
  }

}

class FaqBanner extends HTMLElement {
  searchBar;

  constructor(){
    super();
    this.init();
  } 

  init = () => {
    this.searchBar = new SearchBar(this.querySelector(".header__search-bar-wrapper"));
  }

}

class TagFilter extends HTMLElement {
  inputs;

  constructor(){
    super();
    this.init();
  }

  init = () => {
    this.inputs = this.querySelectorAll('input');
    this.inputs.forEach((input) => {
      input.addEventListener('change', () => {
        this.handleChange(input);
      });
    });
  }

  handleChange = (input) => {
    const newtag = input.value;
    var url = location.pathname;
    const isTag = url.split('/').length > 3;
    if(input.checked){
      const s = isTag ? '+' : '/';
      url = url+s+newtag+window.location.search;
    } else if(isTag) {
      var paths = url.split('/');
      var tags = paths[paths.length-1].split('+');
      const index = tags.indexOf(newtag);
      if(index >= 0)
        tags.splice(index, 1);

      paths.splice(paths.length-1, 1);
      url = paths.join('/');
      if(tags.length > 0){
        url = url+'/'+tags.join('+');
      }
    }
    location.href = url;
  }
}

class McSection extends HTMLElement {
  connectedCallback() {
    if(!this.dataset.url){
      console.error('MC Section: missing url data attribute');
      return;
    }
    if(!this.dataset.section){
      console.error('MC Section: missing section data attribute');
      return;
    }
    this.render();
  }

  render = () => {
    const url = `${this.dataset.url}?section_id=${this.dataset.section}`;
    fetch(url)
      .then(response => response.text())
      .then(html => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const section = doc.querySelector(`.shopify-section`);
        if(!section){
          console.error('MC Section: could not find .shopify-section in loaded section');
          return;
        }
        this.innerHTML = section.innerHTML;
      })
      .catch(error => {
        console.error('Error loading section:', error);
      });
  }
}

if (!window.customElements.get("swiper-element")) {
  window.customElements.define("swiper-element", SwiperElement);
}
if (!window.customElements.get("faq-banner")) {
  window.customElements.define("faq-banner", FaqBanner);
}
if (!window.customElements.get("tag-filter")) {
  window.customElements.define("tag-filter", TagFilter);
}
if (!window.customElements.get("mc-section")) {
  window.customElements.define("mc-section", McSection);
}